import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "thread book-reading__content-editor" }
const _hoisted_2 = { class: "thread__title" }
const _hoisted_3 = { class: "thread-user text-gray" }
const _hoisted_4 = { class: "thread-comment__name" }
const _hoisted_5 = { class: "thread-comment__username" }
const _hoisted_6 = { class: "thread-comment__time" }
const _hoisted_7 = { class: "thread__text" }
const _hoisted_8 = {
  key: 0,
  class: "thread-toolbar"
}
const _hoisted_9 = { class: "article-single__content-editor comment-box" }
const _hoisted_10 = { class: "comment-wrapper" }

import { computed, onBeforeMount, ref } from 'vue'
import type { Raw } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import DocLayout from '@/app/components/doc/Layout.vue'
import Footer from '@/app/components/Footer.vue'
import Comments from '@/app/components/community/Comments.vue'
import CommentEdit from '@/app/components/community/CommentEdit.vue'
import ToggleButton from '@/components/ui/ToggleButton.vue'

import { backend } from '@/services/backend'
import { auth } from '@/services/auth'
import { Sentry } from '@/services/sentry'
import { ThreadView } from '@/models/forum'
import type { DocView } from '@/models/doc'
import { assertNotNull } from '@/helpers/typing'


export default /*@__PURE__*/_defineComponent({
  __name: 'Thread',
  props: {
    doc: {}
  },
  setup(__props: any) {

const props = __props

const route = useRoute()
const router = useRouter()

const commentEdit = ref<InstanceType<typeof CommentEdit> | null>(null)

const isLoading = ref(false)
const thread = ref<Raw<ThreadView> | null>(null)

onBeforeMount(async () => {
  loadThread()
})

async function loadThread(): Promise<void> {
  try {
    isLoading.value = true
    const response = await backend.getThread(route.params.thread as string)
    thread.value = new ThreadView(response, props.doc)
    isLoading.value = false
  } catch (error: any) {
    if (error.request && error.request.status === 404) {
      // Redirect to the non-existing page
      router.push({ name: 'not_found' })
    } else {
      Sentry.captureException(error)
      throw error
    }
  }
}

const isAuthor = computed(() => {
  return !!thread.value && thread.value.author.id === auth.getUserId()
})

function focusReply(): void {
  commentEdit.value?.focusInput()
}
async function updateToggle(value: boolean): Promise<void> {
  await assertNotNull(thread.value).toggleNotifyNewComment(value)
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (!isLoading.value && thread.value)
    ? (_openBlock(), _createBlock(DocLayout, {
        key: 0,
        doc: __props.doc,
        "show-text-controls": false
      }, {
        "page-content": _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h2", _hoisted_2, _toDisplayString(thread.value.title), 1),
            _createElementVNode("p", null, [
              _createElementVNode("span", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _cache[0] || (_cache[0] = _createElementVNode("div", { class: "thread-comment__icon-wrapper" }, [
                    _createElementVNode("span", { class: "iconfont iprofile-icon" })
                  ], -1)),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(thread.value.author.username), 1),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(thread.value.posted_time), 1)
                ])
              ])
            ]),
            _createElementVNode("p", _hoisted_7, _toDisplayString(thread.value.text), 1),
            (isAuthor.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_router_link, {
                    class: "btns btns--white btns--small",
                    to: {
              name: __props.doc.routeNames().edit_thread,
              state: { threadUrlSlug: thread.value.url_slug },
            }
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode(" Edit ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["to"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(ToggleButton, {
            class: "discussion-toggle",
            value: thread.value.notify_new_comment,
            "onUpdate:value": updateToggle
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode(" Notify me of new comments in this discussion ", -1)
            ]))]),
            _: 1
          }, 8, ["value"]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("a", {
                onClick: _withModifiers(focusReply, ["stop","prevent"])
              }, [...(_cache[3] || (_cache[3] = [
                _createElementVNode("i", { class: "iconfont icategory-communication" }, null, -1),
                _createTextVNode(" Comment", -1)
              ]))]),
              _createVNode(CommentEdit, {
                ref_key: "commentEdit",
                ref: commentEdit,
                doc: __props.doc,
                thread: thread.value
              }, null, 8, ["doc", "thread"])
            ]),
            _createVNode(Comments, {
              doc: __props.doc,
              thread: thread.value
            }, null, 8, ["doc", "thread"])
          ]),
          _createVNode(Footer)
        ]),
        _: 1
      }, 8, ["doc"]))
    : _createCommentVNode("", true)
}
}

})